import { createContext, useContext, useState } from "react";
import { Cliente } from "@/interfaces";

type ClienteContextType = {
  cliente: Cliente;
  token: String;
  login: (cliente: Cliente, token: String) => void;
  logout: () => void;
};

const AuthContext = createContext<ClienteContextType>(null!);

const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [cliente, setCliente] = useState<Cliente | null>(() => {
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  });
  const [token, setToken] = useState<String | null>(() => {
    return localStorage.getItem("token");
  });

  const login = (cliente: Cliente, token: String) => {
    localStorage.setItem("token", token.toString());
    localStorage.setItem("user", JSON.stringify(cliente));
    setCliente(cliente);
    setToken(token);
  };

  const logout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    setCliente(null);
    setToken(null);
  };

  return (
    <AuthContext.Provider value={{ cliente, login, logout, token }}>
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
export const useAuth = () => useContext(AuthContext);
